import Link from 'next/link'
import Logo from '../Logo'

export default function Footer() {
  return (
    <div className="border-t border-gray-200 py-2">
      <div className="container mx-auto px-8">
        <div className="grid gap-12 py-8 md:grid-cols-12 lg:pt-12 lg:pb-16">
          <div className="md:col-span-12 lg:col-span-6">
            <Link href="/demo" passHref className="flex" title="Covie demo">

              <Logo dark />

            </Link>
          </div>
          <div className="md:col-span-6 lg:col-span-3">
            <h4 className="mb-6 font-semibold">Useful links</h4>
            <ul className="space-y-4 text-gray-600">
              <li>
                <a
                  target="_blank"
                  href="https://covie.io/#about"
                  rel="noreferrer"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://covie.io/#solutions"
                  rel="noreferrer"
                >
                  Solutions
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.covie.io/request"
                  rel="noreferrer"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-6 lg:col-span-3">
            <h4 className="mb-6 font-semibold">Developers</h4>
            <ul className="space-y-4 text-gray-600">
              <li>
                <Link href="/demo" passHref>
                  Demo
                </Link>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://developer.covie.com/"
                  rel="noreferrer"
                >
                  Documentation
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.covie.io/request"
                  rel="noreferrer"
                >
                  Get access
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="py-2">
          <div className="text-sm text-gray-500">&copy; Covie</div>
        </div>
      </div>
    </div>
  );
}
